export var purchaseEvent = function purchaseEvent(_ref) {
  var _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? "" : _ref$currency,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$shipping = _ref.shipping,
      shipping = _ref$shipping === void 0 ? "" : _ref$shipping,
      _ref$tax = _ref.tax,
      tax = _ref$tax === void 0 ? "" : _ref$tax,
      _ref$transaction_id = _ref.transaction_id,
      transaction_id = _ref$transaction_id === void 0 ? "" : _ref$transaction_id,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      _ref$payment_method = _ref.payment_method,
      payment_method = _ref$payment_method === void 0 ? "" : _ref$payment_method;
  return {
    event: "purchase",
    detailed_event: "Purchase",
    ecommerce: {
      affiliation: items === null || items === void 0 ? void 0 : items.map(function (item) {
        return item.affiliation;
      }),
      currency: currency,
      items: items,
      shipping: shipping,
      tax: tax,
      transaction_id: transaction_id,
      value: value,
      payment_method: payment_method
    }
  };
};